import styled from 'styled-components';

export const LabelUploadCSV = styled('label')`
  display: flex;
  height: 206px;
  width: 852px;
`;
